import store from '@/store'

export const isLogged = () => store.getters['auth/isLogged']

export default {
  isLogged,
}
